export const MODULE_SET_INITIAL_STATE = 'MODULE_SET_INITIAL_STATE';
export const MODULE_FIND_ALL = 'MODULE_FIND_ALL';
export const MODULE_VIEW = 'MODULE_VIEW';
